import React, { useEffect, useState } from 'react';
import RenderFieldBasedOnType from '../RenderFieldsBasedOnType';
import {
    Box,
    Grid,
    Typography,
    Tooltip
} from '@material-ui/core'
import { Helpers } from "dsilo-ui-components";
import { makeStyles } from '@material-ui/core/styles';
import { useCardStyles, useCommonStyles, useInputStyles } from './style';
import { checkConditions } from '../../utils';

/* For now It is static */
const defaultOptions = {}

const SummaryBlock = (props) => {
    const layoutClasses = useCommonStyles()
    const inputClasses = useInputStyles();
    const cardClasses = useCardStyles();

    const { currentDocumentId, formData, selectedStep, block, blockState, handleCheckboxChange, onChange } = props
    const { chartUniqueId } = props.data

    const [blockHeaders, setBlockHeaders] = useState([])


    useEffect(() => {
        if (formData?.dataModel[selectedStep.dataModel]) {
            let dataElements = formData.dataModel[selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (block?.config?.dataElements) {
                    fdes = JSON.parse(JSON.stringify(block?.config?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return { ...sde, ...fde }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                }
            }
        }
    }, [formData?.dataModel, selectedStep?.dataModel, block?.config?.dataElements])


    return (
        <React.Fragment>
            <div className={layoutClasses.columnContainer}>
                <Grid container spacing={1}>
                    {
                        blockHeaders?.length > 0 ? blockHeaders.map((element, index) => {
                            const isFieldReadOnly = element.readOnly;

                            return (
                                checkConditions(element?.conditions, blockState) ? (<Grid
                                    item
                                    key={index}
                                    xs={element.xs ? element.xs : (12 / blockHeaders.length)}
                                    className={layoutClasses.gridItemMargins}
                                >
                                    {
                                        <Box className={layoutClasses.fullWidthBox}>
                                            <Grid container>
                                                <div className={layoutClasses.labelRow}>
                                                    <Tooltip title={element?.label || ''} arrow>
                                                        <Typography
                                                            component='span'
                                                            className={`${layoutClasses.fieldLabel} ${layoutClasses.fieldLabelClamp}`}
                                                        >
                                                            {element.label} :
                                                        </Typography>
                                                    </Tooltip>
                                                </div>

                                                <div className={layoutClasses.fieldWrapper}>
                                                    <RenderFieldBasedOnType
                                                        {...props}
                                                        classes={layoutClasses}
                                                        element={isFieldReadOnly ? { ...element, readOnly: true } : element}
                                                        onChange={onChange}
                                                        handleCheckboxChange={handleCheckboxChange}
                                                        dataObj={blockState}
                                                        options={defaultOptions[element.value || element.name]}
                                                        selectedStep={selectedStep}
                                                        inputClasses={inputClasses}
                                                    />
                                                </div>
                                            </Grid>
                                        </Box>
                                    }
                                </Grid>) : null
                            )
                        }) : (
                            <Typography>{`No Fields are Configured`}</Typography>
                        )
                    }
                </Grid>
            </div>
        </React.Fragment>
    )
}

export default SummaryBlock
